<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt=""/>
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content" data-testid="controlContent">
        <p class="color-basic font-18 font-bold"
           *ngIf="control.elementVal.getValue()?.params.stateTxtId > 0">
            {{ subtitle(control.elementVal.getValue()?.params.stateTxtId) }}
        </p>
        <div class="control__code-key color-basic"
             *ngIf="control.elementVal.getValue()?.params.code >= 0
                && control.elementVal.getValue()?.params.state === 0">
            <p>{{ subtitle(4338) + ': ' + control.elementVal.getValue()?.params.code }}</p>
        </div>
        <div *ngIf="control.elementVal.getValue()?.params.state === 0">
            <input class="control__input border-input font-15"
                   data-testid="codeInput"
                   type="text"
                   [(ngModel)]="control.code">
        </div>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
                data-testid="goBackButton"
                (click)="control.hideControl()"
                *ngIf="control.elementVal.getValue()?.params.state === 0">
            <img class="control__button-img"
                 ngSrc="/assets/img/zone_icons/back.svg"
                 width="40" height="40" alt=""/>
        </button>
        <button class="control__button"
                [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                    'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                    'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                (click)="control.validateCode(control.code)"
                data-testid="sendButton"
                *ngIf="control.elementVal.getValue()?.params.state !== 2">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt=""/>
        </button>
        <button class="control__button control__button--name"
                [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                    'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                    'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="tryAgainButton"
                (click)="control.validateCode(control.code)"
                *ngIf="control.elementVal.getValue()?.params.state === 2">
            <span class="color-light font-18">{{ subtitle(1136) }}</span>
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
